
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CDC_CONFIDENTIAL, CdcConfidentialConfig } from './cdc-confidential.config';

export interface CdcArtifacts {
  UID: string;
  UIDSignature: string;
  signatureTimestamp: string;
  id_token: string;
  baseSite: string; // e.g., 'seqirusb2b-flu360'
}

@Injectable({ providedIn: 'root' })
export class CdcTokenExchangeService {
  constructor(private http: HttpClient, @Inject(CDC_CONFIDENTIAL) private conf: CdcConfidentialConfig) {}

  async exchangeCustomGrant(art: CdcArtifacts) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    // Build /oauth/token x-www-form-urlencoded body for CDC custom grant
    const body = new HttpParams()
      .set('grant_type', 'custom')
      .set('client_id', this.conf.clientId)      // mobile_android
      .set('client_secret', this.conf.clientSecret) // secret
      .set('UID', art.UID)
      .set('UIDSignature', art.UIDSignature)
      .set('signatureTimestamp', art.signatureTimestamp)
      .set('id_token', art.id_token)
      .set('baseSite', art.baseSite);

    const tokenUrl = `${this.conf.tokenUrlBase}/authorizationserver/oauth/token`;
    return firstValueFrom(this.http.post<any>(tokenUrl, body.toString(), { headers }));
  }
}
